import React, { useState, useEffect, useRef } from 'react';
import './Banner.css';

function Banner() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const bannerRef = useRef(null);
  const prevBannerRef = useRef(null);
  
  // 定义四个不同的 Banner 数据
  const bannersData = [
    {
      backgroundImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
    },
    {
      backgroundImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2022/05-07/01352912b6d9465625.png?version=21.3.2',
    },
    {
      backgroundImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2020/12-06/152950ebf253095066.png?version=20.4.5',
    },
    {
      backgroundImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2022/05-07/0136088638f7768110.png?version=21.3.2',
    }
  ];

  // 当前显示的 Banner 数据
  const currentBanner = bannersData[activeIndex];

  // 切换到下一个轮播图
  const nextSlide = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setPrevIndex(activeIndex);
    const nextIndex = (activeIndex + 1) % bannersData.length;
    setActiveIndex(nextIndex);
    
    // 创建前一个Banner的克隆以进行退出动画
    if (bannerRef.current) {
      const clone = bannerRef.current.cloneNode(true);
      clone.className = "banner banner-slide-exit";
      prevBannerRef.current = clone;
      bannerRef.current.parentNode.appendChild(clone);
      
      // 添加新的Banner并设置进入动画
      bannerRef.current.className = "banner banner-slide-enter";
      
      // 动画结束后清理
      setTimeout(() => {
        if (prevBannerRef.current && prevBannerRef.current.parentNode) {
          prevBannerRef.current.parentNode.removeChild(prevBannerRef.current);
        }
        if (bannerRef.current) {
          bannerRef.current.className = "banner";
        }
        setIsAnimating(false);
      }, 500);
    }
  };

  // 自动轮播定时器
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        nextSlide();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isAnimating]);

  return (
    <div className="banner-wrapper">
      <div 
        ref={bannerRef}
        className={`banner ${isHovered ? 'banner-hovered' : ''}`}
        style={{ 
          backgroundImage: `url(${bannersData[activeIndex].backgroundImage})` 
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="banner-content-placeholder"></div>
        
        <div className="banner-indicators">
          {bannersData.map((_, index) => (
            <span 
              key={index} 
              className={`indicator ${activeIndex === index ? 'active' : ''}`}
              onClick={() => {
                if (index > activeIndex) {
                  setIsAnimating(true);
                } else if (index < activeIndex) {
                  setIsAnimating(true);
                }
                setActiveIndex(index);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Banner; 